import '@paypalcorp/pp-vx/dist/core/core';
import '@paypalcorp/pp-vx/dist/core/utilities/transient-view';
import '@paypalcorp/pp-vx/dist/core/utilities/tag-utils';
import '@paypalcorp/pp-vx/dist/components/modal/modalFactory';
import '@paypalcorp/pp-vx/dist/components/selection-menu/selection-menu';
import '@paypalcorp/pp-vx/dist/components/modal/modal';
import '@paypalcorp/pp-vx/dist/components/modal/modalAdmin';
import '@paypalcorp/pp-vx/dist/components/dropdown-menu/dropdown-menu';
import '@paypalcorp/pp-vx/dist/components/accordion/accordion';
import '@paypalcorp/pp-vx/dist/components/text-input/textInput';

// Import custom components
import './ppvx/removeFieldsError';
import './ppvx/layoutHeight';
import './components/loaderSpinner/index';

// Enable all Selection menu components
/* eslint-disable */
(function SelectionMenuRunner(win) {
  const { PPVX } = win
  const { SelectionMenu } = PPVX
  SelectionMenuRunner.initOnLoad = () => {
    const options = {
      callback: ({}),
    }
    PPVX.clickWatcher.addWatcher('selectionMenuRunner', e => {
      if (e.target && e.target.classList.contains('ppvx_select-menu')) {
        SelectionMenu.handleTriggerClick(e, options)
      }
    })
  }
  PPVX.registerObject(SelectionMenuRunner, 'SelectionMenuRunner')
})(window, document)
